import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

type DeployOverlayProps = {
  isVisible: boolean;
  message: string;
};

const DeployOverlay = ({ isVisible, message }: DeployOverlayProps) => {
  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        gap: 1,
      }}
    >
      <CircularProgress size={40} thickness={3} sx={{ color: 'var(--dk-accent, #06C)' }} />
      <Typography
        sx={{
          color: 'var(--dk-text, #000)',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default DeployOverlay;
